// extracted by mini-css-extract-plugin
export default {"melodyVideo":"ZO-z","isFullWidth":"_O-z","landingPageVideo":"aP-z","play":"bP-z","iframeVideo":"cP-z","playHidden":"dP-z","fullwidth":"eP-z"};